<h2 mat-dialog-title> Modificar punto de conexión</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field class='formField'>
      <mat-label>Nombre</mat-label>
      <input matInput placeholder="Nombre" formControlName="name" required>
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Descripción</mat-label>
      <input matInput placeholder="Descripción" formControlName="description">
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Camión por defecto</mat-label>
      <mat-select formControlName="default_id_camion">
        <mat-option [value]="null">Ninguno</mat-option>
        @for (camion of camiones; track camion.id) {
          <mat-option [value]="camion.id">{{ camion.matricula }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Residuo por defecto</mat-label>
      <mat-select formControlName="default_id_material">
        <mat-option [value]="null">Ninguno</mat-option>
        @for (material of materiales; track material.id) {
          <mat-option [value]="material.id">{{ material.nombre }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="cropActions">
      <button mat-stroked-button color="primary" type="button" (click)="openCropper()">
        Configurar recorte
      </button>
    </div>
    <mat-slide-toggle class='sliderCheck' color='primary' [checked]="active" formControlName="active">Activo</mat-slide-toggle>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()">Guardar</button>
</mat-dialog-actions>
